<template>
	<div style="height: 100dvh">
		<Header></Header>
		<router-view></router-view>
		<Footer></Footer>
	</div>
</template>

<script>
import Footer from '../Components/FooterV2.vue';
import Header from '../Components/HeaderV2.vue';
export default {
	components: {
		Header,
		Footer,
	},
};
</script>
